import { Component, AfterViewInit, NgZone, OnDestroy, } from '@angular/core';
// import { MdTabsModule } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import { TdLoadingService, TdMediaService, } from '@covalent/core';

@Component({
  selector: 'qs-modanamnesis',
  templateUrl: './modanamnesis.component.html',
  styleUrls: ['./modanamnesis.component.scss'],
})
export class ModAnamnesisComponent implements AfterViewInit, OnDestroy {

  private _xsScreen: Subscription;
  private hide: boolean = false;

  constructor(private _titleService: Title,
    // private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _ngZone: NgZone, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Anamnesis');
    this.watchScreen();
  }

  /**
   * watchScreen:
   * Observable de cambio de resoluçió.
   * md < 1280px
   */
  watchScreen(): void {
    this._xsScreen = this.media.registerQuery('sm').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          // Ocultamos columnas
          this.hide = true;
        } else {
          // Mostramos columnas
          this.hide = false;
        }
      });
    });
  }

  ngOnDestroy(): void {
    this._xsScreen.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/modanamnesis.component.ts